import { render, staticRenderFns } from "./RuleBid.vue?vue&type=template&id=591d5fec"
import script from "./RuleBid.vue?vue&type=script&lang=js"
export * from "./RuleBid.vue?vue&type=script&lang=js"
import style0 from "./RuleBid.vue?vue&type=style&index=0&id=591d5fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports